import { useTheme } from '@mui/material/styles';
import { getIconComponent, type IconName } from '@malash-office/ui-icons';
import { resolvePaletteColor, type ThemePaletteColor } from '../paletteColorPath';

export type IconSize = 'small' | 'medium' | 'large';

export type IconColor = ThemePaletteColor | 'inherit';

export type IconProps = {
  /** Registered icon name from `@malash-office/ui-icons`. */
  icon: IconName;
  /** @default 'medium' */
  size?: IconSize;
  /** Theme palette path, e.g. `primary.main`, or `inherit`. */
  color?: IconColor;
  titleAccess?: string;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
};

export function Icon({
  icon,
  size = 'medium',
  color = 'inherit',
  titleAccess,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden
}: IconProps) {
  const theme = useTheme();
  const IconComponent = getIconComponent(icon);
  const isDecorative = !ariaLabel && !titleAccess;
  const resolvedColor = color === 'inherit' ? undefined : resolvePaletteColor(theme.palette, color);

  return (
    <IconComponent
      className={['SmIcon-root', `SmIcon-size-${size}`].join(' ')}
      titleAccess={titleAccess}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden ?? isDecorative}
      {...(resolvedColor ? { htmlColor: resolvedColor } : { color: 'inherit' })}
    />
  );
}
